import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getUser, getToken } from "../../Utils/Common";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import styles from "./Circle.module.css";

function CreditThanks(params) {
  // const [loader, setLoader] = useState(true);
  // const [errorMessage, setErrorMessage] = useState("");
  // const [data, setData] = useState([]);
  // const [sucessMessage, setsucessMessage] = useState("");
  // const [error, setError] = useState([]);

  // const book_code = localStorage.getItem("book code");
  const success_message = localStorage.getItem("thanks message");
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const token = getToken();

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + "v1/user/recommended-book",
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        // console.log(response.data.data);
        setData(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err.response.data.message);
        setLoader(false);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      });
  }, []);

  const handleDragStart = (e) => e.preventDefault();
  const images = data.map((img) => {
    // const img = props.images
    return (
      <div className="item" key={img.id}>
        <Link to={`/book-detail/${img.book_code}`}>
          <img
            src={img.image_path}
            onDragStart={handleDragStart}
            role="presentation"
            height="250"
            width="222"
          />
        </Link>
      </div>
    );
  });

  // console.log(images)
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const Carousel = () => (
    <AliceCarousel
      mouseTracking
      items={images}
      responsive={responsive}
      controlsStrategy="alternate"
    />
  );

  return (
    <div className="container-fluid" style={{ marginTop: "140px" }}>
      {/* <div
        className=""
        // id="kt_content_container"
        style={{ marginTop: "50px" }}
      > */}
      <div
        style={{
          textAlign: "center",
          // backgroundColor: "black",
          // padding: "0px",
        }}
        className={styles.shadow}
      >
        <p className="fs-1">
          <strong>{success_message}</strong>
        </p>
        {/* <p className="fs-1"><strong> Thank you! You can now use your Credits! </strong></p> */}
        {/* <hr /> */}
        {/* <div className="row">
          
          <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"></div>
          <div
            className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"
            
            style={{
              marginTop: "50px",

              backgroundColor: "white",
            }}
          >
            <div
              style={{
                fontSize: "60px",
                margin: "20px auto",
                color: "#000",
              }}
              className={styles.circle}
            >
              3
            </div>
            <p className="fs-1"><strong> 3 Extra Credits </strong></p>
          </div>
          <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"></div>
          
        </div> */}
        <div
          className="p-10"
          // style={{ minWidth: "670px" }}
        >
          <div
            className="fs-2tqx rounded-circle"
            style={{
              border: "7px solid black",
              maxWidth: "150px",
              fontSize: "85px",
              margin: "auto",
            }}
          >
            3
          </div>
          {/* <h2 className="fs-2x fw-bolder mt-5">3 Extra Credits</h2>
          <h2 className="fs-2x fw-bolder mt-5">$24.99</h2>
          <h2 className="fs-2x fw-bold mt-5">Only $8.33/credit</h2>

          <button
            className="btn btn-lg btn-dark w-100 mt-5 fs-2hx"
            // onClick={makeTran}
            disabled
          >
            <span className="indicator-label">Buy Now</span>
          </button>

          <h2 className="fs-2x fw-bold mt-5">
            Offer available for a limited time only.
          </h2> */}
        </div>
      </div>

      <div className="container" style={{ marginTop: "30px" }}>
        <div className="card-body py-3 p-18 ms-19 me-19">
          <p className="mb-10 fs-1">Other good recommendations....</p>
          <Carousel />
        </div>
      </div>

      {/* <div style={{ marginTop: "50px" }}>
       
      </div> */}
      {/* </div> */}
    </div>
  );
}

export default CreditThanks;
